import React from 'react';
import ConsensusRevisionWidgetRenderer from './ConsensusRevisionWidgetRenderer';

const Preview: React.FC = () => <ConsensusRevisionWidgetRenderer config={{}} />;

export default Preview;
